import { Box } from '@chakra-ui/layout'
import { } from 'containers'
import { connectNetwork } from 'lib/NetworkProvider'
import { routes, route_from } from 'lib/routes'
import View from 'lib/View'
import moment from 'momentconfig'
import React, { Component } from 'react'

import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Button, Icon, Input, Table } from 'semantic-ui-react'
import { Confirmation, ImageDefault } from '../components'
import { floatTimeToString, timeString } from '../lib/util'

const { app, collections, collectionEdit } = routes

class Collection extends Component {
    constructor(props) {
        super(props)

        this.componentContainerRef = null

        this.setComponentContainerRef = (element) => {
            this.componentContainerRef = element
        }

        let { onCostChange, collection } = props

        this.state = {
            deleting: false,
            ...collection,
            collectionMinutes: collection ? parseFloat(collection.collectionMinutes) : 0,
        }

        if (onCostChange && collection) {
            onCostChange(this.totalCost(), collection.id)
        }
    }

    totalCost() {
        let { collectionHourlyRate, collectionHours, collectionMinutes } = this.state
        let total = (collectionHours + collectionMinutes / 60) * parseFloat(collectionHourlyRate)
        if (isNaN(total)) {
            total = 0
        }
        return total
    }

    componentDidMount() {
        let { collection, id, network } = this.props

        if ((!collection || !collection.id) && id) {
            network.getCollection(id)
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        let { onCostChange, getCollection, login } = this.props
        let { id, collectionHourlyRate } = this.state
        if (collectionHourlyRate !== prevState.collectionHourlyRate) {
            if (onCostChange) {
                onCostChange(this.totalCost(), id)
            }
        }

        // console.log('Collection getCollection fetching', getCollection.fetching)
        if (getCollection && getCollection.fetching !== prevProps.getCollection.fetching && !getCollection.fetching) {
            // console.log('Done calling getCollection')
            if (getCollection.status.success) {
                // console.log(getCollection.data)
                let collection = getCollection.data.data

                this.setState({ ...collection })
                // console.log('Calling Get collection', login, collection)
                /*
				if (login && login.data.user && login.data.user.companies) {
					let company = login.data.user.companies[organization.data[0]]
					// console.log('Calling getFromIdFiltering', company, jobId)
					network.getFromIdFiltering(company, jobId, [
						{
							key: 'timestamp',
							symbol: '>',
							value: moment().subtract(4, 'hours').format('YYYY-MM-DD HH:mm:ss')
						}
					])
				}*/
                return
            } else {
                // console.log('calling No collection found with this id')
            }
        }
    }

    renderBalanceFooter() {
        let { hourtotal, total } = this.props

        let averageHourlyCost = Math.round((total / hourtotal) * 100) / 100
        if (isNaN(averageHourlyCost)) {
            averageHourlyCost = '--'
        }

        return (
            <Table.Row>
                <Table.Cell width="5">Prezzo orario medio: {averageHourlyCost}€/h</Table.Cell>
                <Table.Cell style={{ textAlign: 'right' }} width="4">
                    Totale Ore:
                </Table.Cell>
                <Table.Cell width="4">{floatTimeToString(hourtotal)}</Table.Cell>
                <Table.Cell width="1">Totale:</Table.Cell>
                <Table.Cell width="2">{total}€</Table.Cell>
            </Table.Row>
        )
    }

    renderBalanceHeader() {
        return (
            <Table.Header fullWidth>
                <Table.Row>
                    <Table.HeaderCell width="5">Nome Macchina</Table.HeaderCell>
                    <Table.HeaderCell width="4">Prezzo €/h</Table.HeaderCell>
                    <Table.HeaderCell width="4">Ore di lavoro</Table.HeaderCell>
                    <Table.HeaderCell width="1" />
                    <Table.HeaderCell width="2">Totale</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
        )
    }

    renderForBalance() {
        let { name, collectionHourlyRate, collectionHours, collectionMinutes } = this.state
        return (
            <Table.Row>
                <Table.Cell>{name}</Table.Cell>
                <Table.Cell>
                    <span className="no-print">
                        <Input
                            type="number"
                            step="0.01"
                            value={collectionHourlyRate}
                            onChange={(e, data) => {
                                let value = data.value
                                if (value < 0) value = 0
                                this.setState({
                                    collectionHourlyRate: value,
                                })
                            }}
                        />
                        €/h
                    </span>
                    <span className="only-print">{collectionHourlyRate}€/h</span>
                </Table.Cell>
                <Table.Cell>{timeString(collectionHours, collectionMinutes)}</Table.Cell>
                <Table.Cell>=</Table.Cell>
                <Table.Cell>{this.totalCost()}€</Table.Cell>
            </Table.Row>
        )
    }

    renderTableFooter() {
        let { isBalance } = this.props
        if (isBalance) return this.renderBalanceFooter()
        else return null
    }

    renderTableHeader() {
        let { hideCollection, hideCollectionHours, isBalance } = this.props
        if (isBalance) {
            return this.renderBalanceHeader()
        } else {
            return (
                <Table.Header fullWidth>
                    <Table.Row>
                        {!hideCollection && <Table.HeaderCell>Nome Macchina</Table.HeaderCell>}
                        {!hideCollectionHours && <Table.HeaderCell>Ore di lavoro</Table.HeaderCell>}
                    </Table.Row>
                </Table.Header>
            )
        }
    }

    renderForTable() {
        let { hideCollection, hideCollectionHours, isBalance } = this.props
        let { name, collectionHours, collectionMinutes } = this.state

        if (isBalance) {
            return this.renderForBalance()
        } else {
            return (
                <Table.Row>
                    {!hideCollection && <Table.Cell>{name}</Table.Cell>}
                    {!hideCollectionHours && <Table.Cell>{timeString(collectionHours, collectionMinutes)}</Table.Cell>}
                </Table.Row>
            )
        }
    }

    openRemoveDialog() {
        this.setState({ deleting: true })
    }

    remove() {
        let { network, collection } = this.props

        network.deleteCollection(collection)

        this.setState({ deleting: false })
    }

    render() {
        let { login, type, collection, onClick, selected, noActions, traversable } = this.props
        let { deleting, collectionId: id, collectionName, collectionDescription, collectionImages } = this.state

        let extraprops = {
            fluid: type === 'full' ? true : false,
        }

        if (onClick) {
            extraprops.onClick = () => {
                onClick(collection)
            }
        }
        let user = null
        if (login && login.authenticated) {
            user = login.data.user
        }

        switch (type) {
            case 'footer':
                return this.renderTableFooter()
            case 'header':
                return this.renderTableHeader()
            case 'table':
                return this.renderForTable()
            case 'compact':
                return (
                    <div ref={this.setComponentContainerRef}>
                        <Box style={{ height: 200, width: 200 }}>
                            <Box textStyle="header">Collection compact {collectionName}</Box>
                        </Box>
                    </div>
                )
            default:
                return (
                    <View fullw column between>
                        <Box borderWidth="1px" borderRadius="lg"
                    p="4" overflow="hidden" className={selected ? 'rowSelected' : ''} style={styles.collectionCard} {...extraprops} >
                            <Confirmation
                                message="Vuoi davvero eliminare questa collezione?"
                                showModal={deleting}
                                onConfirm={() => {
                                    this.remove()
                                }}
                                onCancel={() => {
                                    this.setState({ deleting: false })
                                }}
                            />
                            <Box textStyle="content" style={styles.collectionContent}>
                                <View fullw row>
                                    {collectionImages && collectionImages.length > 0 && (
                                        <div style={styles.imageContainer}>
                                            <ImageDefault fromRoot src={collectionImages[0].picturePath} ui={false} style={styles.collectionImage} />
                                        </div>
                                    )}
                                    {!collectionImages ||
                                        (collectionImages.length === 0 && (
                                            <div style={styles.imageContainer}>
                                                <ImageDefault fromRoot src={null} ui={false} style={styles.collectionImage} />
                                            </div>
                                        ))}
                                    <View fullw column>
                                        <span style={styles.header}>{collectionName}</span>
                                        <Box textStyle="description">{collectionDescription}</Box>
                                    </View>
                                </View>
                            </Box>
                            {!noActions && (
                                <Box textStyle="content" extra>
                                    {user && !!user.manage_collections && (
                                        <Button
                                            color="blue"
                                            onClick={() => {
                                                this.props.history.push(route_from(app, collections, collectionEdit, `${id}`))
                                            }}
                                        >
                                            <Icon name="edit" />
                                            Modifica
                                        </Button>
                                    )}

                                    {user && !!user.manage_collections && (
                                        <Button
                                            color="red"
                                            onClick={() => {
                                                this.openRemoveDialog()
                                            }}
                                        >
                                            <Icon name="delete" />
                                            Elimina
                                        </Button>
                                    )}
                                </Box>
                            )}
                            {traversable && (
                                <Box textStyle="content" extra>
                                    <Button
                                        color="yellow"
                                        onClick={() => {
                                            this.props.onTraverse(collection)
                                        }}
                                    >
                                        <Icon name="folder" />
                                        Apri
                                    </Button>
                                    {user && !!user.manage_collections && (
                                        <Button
                                            color="blue"
                                            onClick={() => {
                                                this.props.history.push(route_from(app, collections, collectionEdit, `${id}`))
                                            }}
                                        >
                                            <Icon name="edit" />
                                            Modifica
                                        </Button>
                                    )}
                                </Box>
                            )}
                        </Box>
                    </View>
                )
        }
    }
}

const styles = {
    header: {
        fontSize: '32pt',
        lineHeight: 'normal',
    },
    imageContainer: {
        minWidth: 200,
        minHeight: 150,
        marginRight: 28,
    },
    collectionImage: {
        width: 200,
        height: 150,
        objectFit: 'contain',
    },
    collectionContent: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    collectionCard: {
        marginTop: 8,
        marginBottom: 8,
    },
}

const mapStateToProps = (state) => {
    let { login, getCollection } = state
    let rcode = null
    if (login && login.data && login.data.user) rcode = login.data.user.rcode

    return { role: rcode, getCollection, login }
}

export default withRouter(connect(mapStateToProps)(connectNetwork(Collection)))
